<template>
    <b-card no-body>
        <b-card-header class="d-flex justify-content-between align-items-center pt-75 pb-25">
            <h5 class="mb-0">
                Manager
            </h5>
        </b-card-header>
        <b-card-body>
            <hr>
            <ul class="list-unstyled my-1" v-if="userData">
                <li v-for="(user, index) in userData.usersHierarchique" :key="index">

                    <span class="align-middle">{{ user.lastName }} {{ user.firstName }}</span>


                </li>
            </ul>
        </b-card-body>
    </b-card>
</template>
<script>
import {
    BCard, BCardHeader, BCardBody,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
    directives: {
        Ripple,
    },
    components: {
        BCard,
        BCardHeader,
        BCardBody,
        // BBadge,
        // BButton,
    },
    props: {
        userData: {
            type: Object,
            required: true,
        },

    },
    methods: {
    getUserInitials(user) {
      const firstInitial = user.firstName ? user.firstName.charAt(0).toUpperCase() : ''
      const lastInitial = user.lastName ? user.lastName.charAt(0).toUpperCase() : ''
      return `${lastInitial}${firstInitial}`
    },
},

}
</script>
